<template>
  <div>
    <div v-if="item" v-disable-all="isReadonly">
      <div class="row my-3">
        <div class="col col-md-12">
          <div class="form-group required">
            <label class='control-label'>Дата начала</label>
            <date-component :disabled="isReadonly" v-model="item.dateBegin" :required="true"/>
          </div>
        </div>

        <div class="col col-md-12">
          <div class="form-group required">
            <label class='control-label'>Дата окончания</label>
            <div class="row">
              <template v-if="!isReadonly">
                <div class="col col-md-3 ml-4" style="width:auto;">
                  <input type="checkbox" class="form-check-input" v-model="workNow" id="chbxWorkNow"
                         @change="changeWorkNow">
                  <label for="chbxWorkNow" class="form-check-label">по настоящее время</label>
                </div>
              </template>
              <div class="col">
                <template v-if="isReadonly && !item.dateEnd">
                  <input type="text" class="form-control" disabled="disabled" value="по настоящее время">
                </template>
                <template v-else>
                  <date-component :disabled="isReadonly || workNow" v-model="item.dateEnd"/>
                </template>
              </div>
            </div>
            <div class="invalid-msg" v-if="v$.item.dateEnd.$error">
              <template v-if="v$.item.dateEnd.minValue.$invalid">Дата окончания должна быть больше даты начала
              </template>
              <template v-else-if="v$.item.dateEnd.maxValue.$invalid">Дата окончания не может быть больше текущей даты
              </template>
              <template v-else-if="v$.item.dateEnd.required.$invalid">Поле обязательно для заполнения</template>
            </div>
          </div>
        </div>

        <div class="col  col-md-12">
          <div class="form-group required">
            <component-input
                label="Наименование организации"
                v-model="item.company"
                placeholder="Введите наименование организации"
                required/>
          </div>
        </div>

        <div class="col  col-md-12">
          <div class="form-group required">
            <component-input
                label="Должность"
                v-model="item.position"
                placeholder="Введите должность"
                required/>
          </div>
        </div>

        <div class="col col-md-12">
          <div class="form-group">
            <label class='control-label'>Примечание</label>
            <div><textarea class="form-control" v-model="item.comment"/></div>
          </div>
        </div>
      </div>
    </div>
    <div class="float-right d-flex align-items-center">
      <button-component class="btn btn-primary mx-2" v-if="!isReadonly" v-on:click="save">Сохранить</button-component>
      <button-component type="button" kind="secondary" class="btn btn-default" v-on:click="close">Закрыть
      </button-component>
    </div>
  </div>
</template>
<script>
import API from '../api/applicantWork'
import Constants from '../../../common/constants'
import {requiredIf} from '@vuelidate/validators'
import {useVuelidate} from '@vuelidate/core'
import DateComponent from "@/common/components/DateComponent"
//import moment from 'moment'
import ButtonComponent from "../../../common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import disableAll from "@/common/directives/disable-all";

export default {
  name: "ApplicantWorkCard",
  components: {
    ButtonComponent,
    DateComponent,
    ComponentInput
  },
  directives: {
    'disable-all': disableAll
  },
  props: {
    applicantId: Number,
    cardId: {
      type: Number,
      required: false,
      default: null
    },
    isReadonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created() {
    this.loadPage();
  },
  data() {
    return {
      item: {
        applicantId: 0,
        dateBegin: null,
        dateEnd: null,
      },
      workNow: false
    };
  },
  methods: {
    loadPage() {
      var self = this;
      if (self.cardId) {
        API.find(self.cardId).then(response => {
          self.item = response.data;
          if (!self.item.dateEnd)
            self.workNow = true;
        });
      } else {
        self.item.applicantId = self.applicantId;
        self.workNow = true;
      }
    },
    save() {
      var self = this;

      self.v$.$touch();
      if (self.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }

      API.save(self.item).then(function (response) {
        Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error');
        if (response.data.success) {
          self.$emit('save');
        }
      });
    },
    close() {
      this.$emit('close');
    },
    changeWorkNow() {
      this.item.dateEnd = null;
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        //dateVisit: required
        dateBegin: {
          //required,
          // minValue(val) {
          //     return new Date(val) > new Date();
          // },
          // maxValue(val, {dateEnd}){
          //     return new Date(dateEnd) > new Date(val);
          // }
        },
        dateEnd: {
          required: requiredIf(function () {
            return !this.workNow;
          }),
          minValue(val) {
            if (!val)
              return true;
            return new Date(val) > new Date(this.item.dateBegin);
          },
          maxValue(val) {
            if (!val)
              return true;
            return new Date(val) < new Date();
          },
        },
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.form-group.required .control-label:after {
  content: "*";
  color: red;
}
</style>